import React, { useMemo } from 'react';
import { Form, Typography } from 'antd';
import _ from 'lodash';
import { generateFormFields, FieldTypes } from 'utils/formUtils';
import { PermissionSetMap } from 'constants/RBACConstants';
import { getVocabulary } from 'components/Vocabulary';
import { hasPermission } from 'utils/authService';

const { Title, Text } = Typography;

const severity = () => getVocabulary('severity');
const severityLower = () => getVocabulary('severity').toLowerCase();
const mitigated = () => getVocabulary('mitigated');

const ToolFindingStatusSeverityPreference = ({ updatePreference, reopenSource, onPreferenceChange }) => {
    const visibleReopenResource = updatePreference !== 'LATEST';

    const fields = useMemo(() => {
        const options = [
            { label: `ArmorCode Status/${severity()} (Recommended)`, value: 'ARMORCODE' },
            { label: `Security Tool Status/${severity()}`, value: 'LATEST' },
        ];
        return [
            {
                name: 'updatePreference',
                type: FieldTypes.RADIO,
                disabled: !hasPermission(PermissionSetMap.UPDATE_GLOBAL_SETTING),
                options,
            },
            ...(visibleReopenResource ? [{
                name: 'reopenSource',
                type: FieldTypes.BOOLEAN,
                label: `For reopen scenarios, set Status/${severity()} to the value that was present before findings was ${mitigated()}.`,
                inline: true,
                disabled: !hasPermission(PermissionSetMap.UPDATE_GLOBAL_SETTING)
            }] : [])
        ];
    }, [visibleReopenResource]);

    const onValuesChange = (changed) => {
        if (!_.isUndefined(changed.updatePreference)) {
            onPreferenceChange({
                updatePreference: changed.updatePreference,
                reopenSource: changed.updatePreference === 'LATEST' ? false : reopenSource
            });
        }
        if (!_.isUndefined(changed.reopenSource)) {
            onPreferenceChange({ updatePreference, reopenSource: changed.reopenSource });
        }
    };

    return (
        <div className="p-y-sm">
            <Title level={5}>{`Finding Status/ ${severity()} Preference`}</Title>
            <div className="p-b-xs">
                {`ArmorCode honors status/${severityLower()} change from the security tool till the time the status/${severityLower()} of a finding gets updated by ArmorCode user or runbook. Subsequently, you can choose how ArmorCode would behave.`}
            </div>
            <div className="p-b-xs">
                <Text strong>{`ArmorCode Status/${severity()} (Recommended) :`}</Text>{' '}
                <Text>{`Once ArmorCode status/${severityLower()} for a finding is updated manually or via a runbook, ArmorCode will not accept any update to finding status/${severityLower()} coming from security tool.`}</Text>
            </div>
            <div>
                <Text strong>{`Security Status/${severity()} :`}</Text>{' '}
                <Text>{`ArmorCode will always accept update to finding status/${severityLower()} coming from security tool.`}</Text>
            </div>
            <Form layout="vertical" fields={[
                { name: 'updatePreference', value: updatePreference },
                { name: 'reopenSource', value: reopenSource }
            ]} onValuesChange={onValuesChange}>
                {generateFormFields(fields)}
            </Form>
        </div>
    );
};

export default ToolFindingStatusSeverityPreference;
